import type {
	AtAGlanceRequestOptions,
	AtAGlanceRequestDependencies,
	AtAGlanceResponse,
} from './atAGlanceTypes.ts';

const ENDPOINT = '/gateway/api/ai/v2/ai-feature/twg-hub-summaries';
const EXPERIENCE_ID = 'confluence-twg-hub-summaries';

export const sendAtAGlanceRequest = (
	{ cloudId, requestBody, signal }: AtAGlanceRequestOptions & { signal: AbortSignal },
	fetchRequest: AtAGlanceRequestDependencies['fetch'],
	onResponse: (response: AtAGlanceResponse, responseBody: unknown) => void,
): Promise<void> =>
	fetchRequest(ENDPOINT, {
		method: 'POST',
		credentials: 'include',
		headers: {
			'Content-Type': 'application/json',
			Accept: 'application/json',
			'ATL-CloudId': cloudId,
			'x-experience-id': EXPERIENCE_ID,
			'x-product': 'confluence',
		},
		body: requestBody,
		signal,
	}).then(async (response) => {
		const responseBody: unknown = await response.json().catch(() => null);
		// Calling the handler here preserves cancellation ordering and lets its errors
		// reject this promise for the request's failure handler.
		onResponse(response, responseBody);
	});
